export const LineArtLady = ({ className = "" }) => (
  <svg
    viewBox="0 0 200 240"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M100 62 C 85 62 76 78 76 102 C 76 130 87 150 100 150 C 113 150 124 130 124 102 C 124 78 115 62 100 62" />
    <path d="M84 92 C 89 88 95 88 98 91" />
    <path d="M102 91 C 105 88 111 88 116 92" />
    <path d="M85 102 C 89 106 95 106 98 103" />
    <path d="M102 103 C 105 106 111 106 115 102" />
    <path d="M100 108 C 99 114 98 119 102 122" />
    <path d="M92 133 C 96 130 104 130 108 133" />
    <path d="M92 133 C 96 138 104 138 108 133" />
    <path d="M100 44 C 62 44 46 80 52 122 C 56 152 46 182 32 202" />
    <path d="M100 44 C 138 44 154 80 148 122 C 144 152 154 182 168 202" />
    <path d="M64 72 C 54 98 58 128 70 150" />
    <path d="M136 72 C 146 98 142 128 130 150" />
    <path d="M52 128 C 42 150 44 174 54 192" />
    <path d="M148 128 C 158 150 156 174 146 192" />
  </svg>
);
